<template>
	<div v-if="loading" class="cog-field__placeholder cog-input cog-lookup--loading" :class="{'is-read-only': readonly}">
		<div class="cog-field__placeholder-inner">
			<!-- The nbsp is to emulate the space of a real input -->
			&nbsp;
			<i-cog />
		</div>
	</div>
	<div v-else class="cog-choice cog-lookup">
		<slot :data="slot" :choiceOptions="choiceOptions"></slot>
	</div>
</template>

<script>
	import CCascadeFilter from './CascadeFilter';
	export default CCascadeFilter;
</script>